import React from 'react'
import PropTypes from 'prop-types'
import './commonSkeleton.less'

const CommonSkeleton = (props) => {
  const { isLoading } = props
  return (
    <>
      {isLoading && (
        <div className={'skeleton_wrapper'}>
          <img
            class="loader-icon"
            src="https://storage.googleapis.com/cubyts-as1-public/public/email_assets/Cubyts_Loader@2x.gif"
            alt="Loading..."
            style={{ width: '160px' }}
          />
        </div>
      )}
    </>
  )
}

CommonSkeleton.propTypes = {
  isLoading: PropTypes.bool,
}
CommonSkeleton.defaultProps = {
  isLoading: true,
}
export default CommonSkeleton
